<template>
    <div >   
        <router-link to="/" class="a-10">
            <v-img class="" style="width:300px;position: absolute; top:10%;margin-left: auto;margin-right: auto;left: 0;right: 0;" alt="logo" src="@/assets/img/logo-genl.svg"></v-img>
        </router-link>
        <v-row class="w-100" style="height:100vh">
            <v-col cols="12" md="6" lg="6" justify="center" class="mx-auto my-auto d-flex flex-column align-center"  >
                <v-card class="pa-6" style="width:100%">
                    <!-- <v-img class="logo_tam" alt="Tamaulipas Logo" src="@/assets/img/logo_nl.png"></v-img> -->
                    <v-card-title class="justify-center" style="color:#AF8C55">Recuperación de contraseña</v-card-title>
                    <v-divider class="my-4"></v-divider>
                    <v-card-text class="mt-6 d-flex flex-column">
                        <!-- LOGIN FORM -->
                        <v-form  ref="passwordRescueForm" v-model="formValid">
                            <label for="" class="label-form ">Nueva contraseña</label>
                            <v-text-field
                                class=""
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[formValidator.password.required, formValidator.password.min]"
                                :type="showPassword ? 'text' : 'password'"
                                placeholder="Ingresa una nueva contraseña"
                                @click:append="showPassword = !showPassword"
                                outlined required v-model="request.password"
                                name="password"
                            ></v-text-field>

                            <label for="" class="label-form ">Repite la nueva contraseña</label>
                            <v-text-field
                                class=""
                                :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[formValidator.password.passwordMatch(request.confirm_password, request.password)]"
                                :type="showRepeatPassword ? 'text' : 'password'"
                                placeholder="Confirma la nueva contraseña"
                                @click:append="showRepeatPassword = !showRepeatPassword"
                                outlined required v-model="request.confirm_password"
                            ></v-text-field>

                            <v-row align="center" style="width:75%;margin: auto" justify="center">
                                    <v-btn @click="1" :color="pantone" large class=" flex-fill mr-2 mt-2 white--text">Cancelar</v-btn>
                                    <v-btn @click="updatePassword()" :color="pantoneBlack" large class="flex-fill mr-2 mt-2 white--text">Continuar</v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

</template>  

<script>
import {mapActions, mapState} from 'vuex'
import registerFormValidator from "bestgob-core/form/register.form.validator";

export default {
    data() {
        return {
            formValidator: registerFormValidator,
            request: {password: null, confirm_password: null, dato: null, reset_token: null, client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID},

            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
            pantone: '#B08C55',
            pantoneBlack: '#15212F'
        }
    },
    computed: {
        ...mapState({accountStore: state => state.account}),
    },

    created() {
        this.$gtag.event('recuperar_contrasenia', { method: 'Google' }) // Google Analytics
    },

    mounted() {
        if (this.accountStore.loggedIn){
            this.$router.push({name: 'home'})
        }

        this.request.dato = this.$route.query.dato
        this.request.reset_token = this.$route.query.reset_token
    },

    methods: {
        ...mapActions('account', ['setNewUserPassword']),

        updatePassword(){
            this.$refs.passwordRescueForm.validate()

            if (this.formValid){
                this.setNewUserPassword(this.request)
            }
        }
    },

};
</script>
<style>
    .v-application.fondo_login fieldset{
        border-bottom: 0px !important
    }
    /* .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        min-height: unset !important;
    } */

    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
    }

    .v-text-field--focused{
        transition: unset !important;   
    }

    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
</style>
